module.exports = __webpack_public_path__ + "static/awesomenesstv_logo.0628a468.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/awesomenesstv_logo.png
// module id = 472
// module chunks = 35783957827783